export function isElectron(): boolean {
  return typeof window !== 'undefined' && Boolean(window.electronAPI);
}

export const APP_DOWNLOAD_URL = 'https://omnimind.com.cn/fluxmind';
